(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('job-title', {
            parent: 'entity',
            url: '/job-title?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.jobTitle.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/job-title/job-titles.html',
                    controller: 'JobTitleController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('jobTitle');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('job-title-detail', {
            parent: 'entity',
            url: '/job-title/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.jobTitle.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/job-title/job-title-detail.html',
                    controller: 'JobTitleDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('jobTitle');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'JobTitle', function($stateParams, JobTitle) {
                    return JobTitle.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('job-title.new', {
            parent: 'job-title',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/job-title/job-title-dialog.html',
                    controller: 'JobTitleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                displayOrder: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('job-title', null, { reload: true });
                }, function() {
                    $state.go('job-title');
                });
            }]
        })
        .state('job-title.edit', {
            parent: 'job-title',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/job-title/job-title-dialog.html',
                    controller: 'JobTitleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['JobTitle', function(JobTitle) {
                            return JobTitle.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('job-title', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('job-title.delete', {
            parent: 'job-title',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/job-title/job-title-delete-dialog.html',
                    controller: 'JobTitleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['JobTitle', function(JobTitle) {
                            return JobTitle.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('job-title', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
